/* mb-gallery-loop.js
 * Mobile product gallery → Swiper loop carousel with a peek of the PREVIOUS
 * and NEXT photo on both sides (incl. the first photo, which loops to the
 * last). Clean single implementation:
 *   - loop + centeredSlides + slidesPerView:'auto' (slide width = 78vw via CSS)
 *   - espresso pagination dots; native swipe; clickable dots
 *   - NO nav arrows, NO extra zoom button (native lightbox handles zoom)
 * Uses CSS transforms (not overflow-scrolling), so it cannot reproduce the
 * iOS "sticky image" vertical-scroll bug. Desktop (>=750px) tears Swiper down
 * and Dawn's native thumbnail gallery is used. If Swiper fails to load, the
 * CSS scroll-snap peek (in mb-custom.css) remains as a no-JS fallback.
 */
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function items(list) { return Array.prototype.slice.call(list.querySelectorAll('.product__media-item')); }

  function build(list) {
    if (list.__mbSw || typeof window.Swiper !== 'function') return;
    if (items(list).length < 2) return;

    list.classList.add('swiper-wrapper');
    items(list).forEach(function (it) { it.classList.add('swiper-slide'); });

    var sw = document.createElement('div');
    sw.className = 'swiper mb-gal-swiper';
    list.parentNode.insertBefore(sw, list);
    sw.appendChild(list);

    var pag = document.createElement('div');
    pag.className = 'swiper-pagination mb-gal-pag';
    sw.appendChild(pag);

    list.__mbSwEl = sw;
    list.__mbSw = new window.Swiper(sw, {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      watchOverflow: true,
      autoHeight: true,
      pagination: { el: pag, clickable: true },
      on: {
        // recompute height once the active slide's image has loaded, so the
        // dots/title land right under whatever image is showing (square or
        // portrait) instead of under a stale/zero height.
        imagesReady: function () { this.updateAutoHeight(0); },
        slideChange: function () { this.updateAutoHeight(250); }
      }
    });
  }

  function teardown(list) {
    if (list.__mbSwPoll) { window.clearInterval(list.__mbSwPoll); list.__mbSwPoll = null; }
    if (list.__mbSw) { try { list.__mbSw.destroy(true, true); } catch (e) {} list.__mbSw = null; }
    var sw = list.__mbSwEl;
    if (sw && sw.parentNode) {
      var pag = sw.querySelector('.mb-gal-pag');
      if (pag) pag.remove();
      sw.parentNode.insertBefore(list, sw);
      sw.remove();
    }
    list.__mbSwEl = null;
    list.classList.remove('swiper-wrapper');
    items(list).forEach(function (it) { it.classList.remove('swiper-slide'); });
  }

  function sync(list) {
    if (isMobile()) {
      if (!list.__mbSw) {
        if (typeof window.Swiper === 'function') {
          build(list);
        } else if (!list.__mbSwPoll) {
          var tries = 0;
          list.__mbSwPoll = window.setInterval(function () {
            tries++;
            if (typeof window.Swiper === 'function' || tries > 40 || !isMobile()) {
              window.clearInterval(list.__mbSwPoll);
              list.__mbSwPoll = null;
              sync(list);
            }
          }, 50);
        }
      }
    } else if (list.__mbSw) {
      teardown(list);
    }
  }

  /* Variant colour change → jump the carousel to that variant's photo. */
  function bindVariant(list) {
    if (list.__mbVar) return;
    list.__mbVar = true;
    var section = list.closest('.shopify-section') || document;
    section.addEventListener('change', function (e) {
      if (!list.__mbSw) return;
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        window.setTimeout(function () {
          var active = list.querySelector('.product__media-item[aria-hidden="false"], .product__media-item.is-active');
          if (active) {
            var idx = active.getAttribute('data-swiper-slide-index');
            if (idx != null) { try { list.__mbSw.slideToLoop(parseInt(idx, 10)); } catch (e2) {} }
          }
        }, 260);
      }
    });
  }

  function run() { document.querySelectorAll('.product__media-list').forEach(sync); }
  function init() {
    document.querySelectorAll('.product__media-list').forEach(bindVariant);
    run();
  }

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', init);
})();
